export default {
  FIRST_LOAD: 'FIRST_LOAD',
};
